import { DataProcessingArgs } from 'src/api-new/bifrost';

export const ARG_DRAFT_ID = 'ARG_DRAFT_ID';
export const defaultDraftArg: DataProcessingArgs = {
  id: ARG_DRAFT_ID,
  type: 'text',
  description: '',
  key: '',
};
